import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import { PartnerProfilePage } from "@/pages/partner/PartnerAccountPages";

export const Route = createFileRoute("/partner/profile")({
  head: () => pageHead("Partner Profile", "Your personal details in the AKIVA Partner workspace.", "/partner/profile", true),
  component: PartnerProfilePage,
});
